import { ListItem } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekListItem = styled(ListItem)(({ theme, leftBorderAccentColor, selected, bordered, backgroundColor }) => (Object.assign(Object.assign({ margin: 0, padding: 0, fontSize: `${theme.typography.h5}` }, ((bordered && {
    ":first-of-type": {
        borderTop: `1px solid ${theme.palette.divider}`,
    },
    borderBottom: `1px solid ${theme.palette.divider}`,
}) ||
    {})), { borderLeft: `${theme.spacing(0.2)} solid ${(selected && leftBorderAccentColor) || "transparent"}`, "&.Mui-selected": {
        backgroundColor: selected ? backgroundColor || theme.palette.grey[50] : backgroundColor || "transparent",
    } })));

export { PeekListItem, PeekListItem as default };
